import React from 'react'
import './banner.css'
const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];

const Theme2NoPhotoBanner = ({ values }) => {

    const isLargeNameFont = LARGE_NAME_FONTS.includes(
  values?.nameFontStyle
); 
 
  const noPhotoGroomNameDisplay = () => {
    return (
      <h3
          className={`t2-preview-banner-name ${
        isLargeNameFont ? "t2-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
          {values.groomName || "Groom"}
      </h3>
    );
  };

    const noPhotoBrideNameDisplay = () => {
    return (
      <h3
        className={`t2-preview-banner-name ${
        isLargeNameFont ? "t2-preview-banner-name--compact" : ""
      }`}
        style={{ fontFamily: values.nameFontStyle }}
      >
        {values.brideName || "Bride"}
      </h3>
    );
  };
 
 
  return (
  <>
     <img src="/theme2coverbg.jpg" alt="cover-img"  />
      <img src="/theme2coverAsset.png" alt=""  className='t2-preview-banner-frame-border t2-preview-banner-frame-border-top' />  
       <img src="/theme2coverAsset.png" alt=""  className='t2-preview-banner-frame-border t2-preview-banner-frame-border-bottom' />  
       <div className="t2-preview-cover-details">
         <span className="t2-preview-no-photo-cover-content">
          We are honored to welcome you to the wedding ceremony of
        </span>
         <div className="t2-preview-cover-name-wrapper">
         {values.displayOrder==="groomFirst"?(
          <>
               {noPhotoGroomNameDisplay()}
                <span 
                  className={`t2-preview-banner-and ${
        isLargeNameFont ? "t2-preview-banner-and--compact" : ""
      }`}
                 style={{ fontFamily: values.nameFontStyle }}>&</span>
                   {noPhotoBrideNameDisplay()}

          </>
         ):<>
    {noPhotoBrideNameDisplay()}
                <span 
                      className={`t2-preview-banner-and ${
        isLargeNameFont ? "t2-preview-banner-and--compact" : ""
      }`}
                style={{ fontFamily: values.nameFontStyle }}>&</span>
                  {noPhotoGroomNameDisplay()}
         </>}
         </div>
          <div className="t2-preview-banner-hashtag">  
               {values.hashtag ? `#${values.hashtag}` : ""}
           </div>
       </div>      
  </>
  )
}

export default Theme2NoPhotoBanner